export const BENCHMARK_IMAGE_WIDTH = 1920;
export const BENCHMARK_IMAGE_HEIGHT = 1080;
export const BENCHMARK_IMAGE_ACCEPT = "image/png,image/jpeg";
export const BENCHMARK_IMAGE_SIZE_ERROR = `Upload an image that is exactly ${BENCHMARK_IMAGE_WIDTH}×${BENCHMARK_IMAGE_HEIGHT}.`;
export const BENCHMARK_IMAGE_TYPE_ERROR = "Choose a PNG or JPG image.";
export const BENCHMARK_IMAGE_READ_ERROR =
  "That image couldn't be read. Try another file.";

export function readImageDimensions(
  file: File,
): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve({ width: image.naturalWidth, height: image.naturalHeight });
    };
    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error(BENCHMARK_IMAGE_READ_ERROR));
    };
    image.src = objectUrl;
  });
}

export async function validateBenchmarkImageFile(
  file: File,
): Promise<string | null> {
  if (!BENCHMARK_IMAGE_ACCEPT.split(",").includes(file.type.toLowerCase())) {
    return BENCHMARK_IMAGE_TYPE_ERROR;
  }

  try {
    const { width, height } = await readImageDimensions(file);
    if (width !== BENCHMARK_IMAGE_WIDTH || height !== BENCHMARK_IMAGE_HEIGHT) {
      return BENCHMARK_IMAGE_SIZE_ERROR;
    }
  } catch {
    return BENCHMARK_IMAGE_READ_ERROR;
  }

  return null;
}
